const BaseMissingInterpolatedValuesHandler = require('./BaseMissingInterpolatedValuesHandler')

module.exports = class ShowConsoleErrorOnMissingInterpolatedValuesHandler extends BaseMissingInterpolatedValuesHandler {
  handleMissingInterpolatedValue(message, value) {
    this.loggingService.logError(
      `I18n Formatter: The value {${value}} required by message "${message}" was not supplied.`
    )
  }
}
